import AliasEqualsSelector from '../AliasEqualsSelector';
import ColorEqualsComparator from './ColorEqualsComparator';
import { options } from '../../../views/pairing/editor/ColorOption';
const opts = options.sort((optA, optB) => {
  return optA.name > optB.name ? 1 : -1;
});
export default AliasEqualsSelector.create(ColorEqualsComparator, opts);